module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_flower_2-90649cea5006dfeb7c82179937202d09.jpg";